__webpack_require__.p = "//s3.meituan.net/static-prod01/ws-assets/com.sankuai.show.mmh5.static/QSp1JUK5mw2tjeFFoGDbw/";